import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const ordersNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Orders,
  icon: 'store',
  route: `/${RoutesEnum.Orders}`,
};
